import { SkeletonWoo } from '@/components/skeleton/skeleton.woo';
import { WooChevronRight, WooLockOn } from '@nosinovacao/fe-icons';
import { Button, ImageProfile, mage, useI18n } from '@nosinovacao/nosid-mfe-common';
import { type TvProfilesListProps } from '../-model/props';
import { AvatarPictureWoo } from '../../-components/avatar-picture.woo';
import { Link } from '@tanstack/react-router';

export function TvProfilesListWoo({ profiles, isLoading, sa }: Readonly<TvProfilesListProps>) {
  const { t } = useI18n();
  return (
    <main className="relative flex size-full flex-col overflow-y-auto">
      <SkeletonWoo loading={isLoading} className="mb-3 h-[4.5rem] w-full shadow-1" count={4}>
        <div className="grid gap-2">
          {!profiles.length ? (
            <span
              data-tid="text-no-profiles"
              className="text-center font-medium text-nos-neutral-900 font-text-p1"
            >
              {t('TvProfiles.LandingPage.NoProfiles')}
            </span>
          ) : (
            profiles
              .filter((profile) => profile.ProfileId)
              .map((profile) => (
                <Link
                  data-tid="link-edit-profile"
                  to="/tv/$id/profiles/$profileId/update"
                  params={{
                    id: sa,
                    profileId: profile.ProfileId!,
                  }}
                  search={{ hasPin: !!profile.Pin, kids: profile.Type === 'Kids' }}
                  className="flex items-center gap-3 border border-nos-neutral-200 bg-nos-neutral-0 p-4 [&>*]:shrink-0"
                  key={profile.ProfileId}
                >
                  <AvatarPictureWoo
                    size={40}
                    src={mage.getImage(profile.Avatar?.ImageUri, ImageProfile.Avatar)}
                    name={profile.Nickname}
                  />
                  <span data-tid="text-profile-name" className="text-nos-neutral-900 font-text-p1">
                    {profile.Nickname}
                  </span>
                  <div className="ml-auto flex items-center gap-4 text-nos-neutral-500">
                    {profile.Pin ? <WooLockOn width={20} height={20} /> : null}
                    <WooChevronRight width={20} height={20} />
                  </div>
                </Link>
              ))
          )}
        </div>
      </SkeletonWoo>
      <div className="sticky bottom-0 mt-auto grid gap-4 bg-nos-neutral-0 pt-6 max-tablet:pb-8 tablet:grid-cols-2">
        <Button data-tid="button-create-kid-profile" skin="woo" variant="secondary" asChild>
          <Link to="/tv/$id/profiles/create" params={{ id: sa }} search={{ kids: true }}>
            {t('TvProfiles.LandingPage.CreateKidProfile')}
          </Link>
        </Button>
        <Button data-tid="button-create-profile" skin="woo" asChild>
          <Link to="/tv/$id/profiles/create" params={{ id: sa }} search={{ kids: false }}>
            {t('TvProfiles.LandingPage.CreateProfile')}
          </Link>
        </Button>
      </div>
    </main>
  );
}
